import { Routes, Route } from 'react-router-dom';
import PrivateRoute from './PrivateRoute';
import AdminPage from '../components/Pages/Admin';
import LoginPage from '../components/Pages/Login';
import HomePage from '../components/Pages/Home';
import HistoryChatsPage from '../components/Pages/HistoryChats';
import DashboardPage from '../components/Pages/Dashboard';
import DynamicChats from '../components/Pages/Chats';

import HomeSkeleton from '../components/Pages/Home/HomeSkeleton';
import MainLayout from '../components/Templates/Layout';
import NaoEncontradoTemplate from '../components/Templates/Chats/NaoEncontrado';
import UserProfileSkeleton from '../components/Pages/UserProfile/UserProfileSkeleton';
import LockedPage from '../components/Pages/Locked';
import UserProfilePage from '../components/Pages/UserProfile';
import ProjectsPage from '../components/Pages/Projects';
import NewProjectPage from '../components/Pages/NewProject';
import SummaryProjectPage from '../components/Pages/SummaryProject';
import ReviewProjectPage from '../components/Pages/ReviewProject';
import EditProjectPage from '../components/Pages/EditProject';
import ProjectPage from '../components/Pages/Project';
import BrainstormPage from '../components/Pages/Brainstorm';
import BrainstormIdeasPage from '../components/Pages/BrainstormIdeas';
import BrainstormIdeasEditPage from '../components/Pages/BrainstormIdeasEdit';
import BrainstormConceptsPage from '../components/Pages/BrainstormConcepts';
import BrainstormConceptsEditPage from '../components/Pages/BrainstormConceptsEdit';
import PdfReaderPage from '../components/Pages/PdfReader';

function RouterApp() {
    return (
        <Routes>
            <Route
                path="/"
                element={
                        <MainLayout>
                            <HomePage />
                        </MainLayout>
                }
            />
            <Route
                path="/login"
                element={<LoginPage />}
            />
            <Route
                path="/projects"
                element={
                        <PrivateRoute skeleton={HomeSkeleton}>
                            <MainLayout>
                                <ProjectsPage />
                            </MainLayout>
                        </PrivateRoute>
                }
            />
            <Route
                path="/project/:id"
                element={
                    <PrivateRoute skeleton={HomeSkeleton}>
                        <MainLayout>
                            <ProjectPage />
                        </MainLayout>
                    </PrivateRoute>
                }
            />
            <Route
                path="/new-project"
                element={
                        <PrivateRoute skeleton={HomeSkeleton}>
                            <MainLayout>
                                <NewProjectPage />
                            </MainLayout>
                        </PrivateRoute>
                }
            />
            <Route
                path="/summary-project"
                element={
                    <PrivateRoute skeleton={HomeSkeleton}>
                        <MainLayout>
                            <SummaryProjectPage />
                        </MainLayout>
                    </PrivateRoute>
                }
            />
            <Route
                path="/review-project/"
                element={
                    <PrivateRoute skeleton={HomeSkeleton}>
                        <MainLayout>
                            <ReviewProjectPage />
                        </MainLayout>
                    </PrivateRoute>
                }
            />
            <Route
                path="/edit-project/:id"
                element={
                    <PrivateRoute skeleton={HomeSkeleton}>
                        <MainLayout>
                            <EditProjectPage />
                        </MainLayout>
                    </PrivateRoute>
                }
            />
            <Route
                path="/brainstorm/:projectId"
                element={
                    <PrivateRoute skeleton={HomeSkeleton}>
                        <MainLayout>
                            <BrainstormPage />
                        </MainLayout>
                    </PrivateRoute>
                }
            />
            <Route
                path="/brainstorm/ideas/:projectId"
                element={
                    <PrivateRoute skeleton={HomeSkeleton}>
                        <MainLayout>
                            <BrainstormIdeasPage />
                        </MainLayout>
                    </PrivateRoute>
                }
            />
            <Route
                path="/brainstorm/ideas/:projectId/:outputId"
                element={
                    <PrivateRoute skeleton={HomeSkeleton}>
                        <MainLayout>
                            <BrainstormIdeasEditPage />
                        </MainLayout>
                    </PrivateRoute>
                }
            />
            <Route
                path="/brainstorm/concepts/:projectId"
                element={
                    <PrivateRoute skeleton={HomeSkeleton}>
                        <MainLayout>
                            <BrainstormConceptsPage />
                        </MainLayout>
                    </PrivateRoute>
                }
            />
            <Route
                path="/brainstorm/concepts/:projectId/:outputId"
                element={
                    <PrivateRoute skeleton={HomeSkeleton}>
                        <MainLayout>
                            <BrainstormConceptsEditPage />
                        </MainLayout>
                    </PrivateRoute>
                }
            />
            <Route
                path="/home"
                element={

                    <PrivateRoute
                        skeleton={HomeSkeleton}
                    >

                        <MainLayout>
                            <HomePage />
                        </MainLayout>

                    </PrivateRoute>

                }
            />
            <Route
                path="/admin"
                element={
                    <PrivateRoute
                        skeleton={HomeSkeleton}
                        requiredRole='admin'>
                        <MainLayout>
                            <AdminPage />
                        </MainLayout>
                    </PrivateRoute>
                }
            />
            <Route
                path="/profile"
                element={
                    <PrivateRoute
                        skeleton={UserProfileSkeleton}
                        requiredRole='user'>
                        <MainLayout>
                            <UserProfilePage />
                        </MainLayout>
                    </PrivateRoute>
                }
            />
            <Route
                path="/history-chats"
                element={

                    <PrivateRoute
                        skeleton={HomeSkeleton}
                        requiredRole='user'
                    >

                        <MainLayout>
                            <HistoryChatsPage />
                        </MainLayout>

                    </PrivateRoute>

                }
            />
            <Route
                path="/dashboard"
                element={
                    <PrivateRoute
                        skeleton={HomeSkeleton}
                        requiredRole='superuser'>
                        <MainLayout>
                            <DashboardPage />
                        </MainLayout>
                    </PrivateRoute>
                }
            />
            <Route
                path="/chat/:projectId/:chatId"
                element={
                    <PrivateRoute
                        skeleton={HomeSkeleton}
                    >
                        <MainLayout>
                            <DynamicChats />
                        </MainLayout>

                    </PrivateRoute>
                }
            />
            <Route
                path="/chat/:projectId"
                element={
                    <PrivateRoute
                        skeleton={HomeSkeleton}
                    >
                        <MainLayout>
                            <DynamicChats />
                        </MainLayout>

                    </PrivateRoute>
                }
            />
            <Route
                path="/pdf-reader"
                element={
                    <PrivateRoute skeleton={HomeSkeleton}>
                        <MainLayout>
                            <PdfReaderPage />
                        </MainLayout>
                    </PrivateRoute>
                }
            />
            <Route
                path="/locked"
                element={
                    <PrivateRoute>
                        <LockedPage />
                    </PrivateRoute>
                }
            />
            <Route
                path="*"
                element={
                    <PrivateRoute>
                        <MainLayout>
                            <NaoEncontradoTemplate />
                        </MainLayout>
                    </PrivateRoute>
                }
            />
        </Routes>
    );
}

export default RouterApp;
